import { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { State } from 'redux/initialState';
import { useTranslate } from 'hooks/useTranslate';
import { getAiUsage } from 'modules/ai/redux/aiActions';

type AiUsageIndicatorProps = {
  societyId: string;
};

function formatTokens(n: number): string {
  if (n >= 1_000_000)
    return `${(n / 1_000_000).toFixed(n % 1_000_000 === 0 ? 0 : 1)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(n % 1_000 === 0 ? 0 : 1)}K`;
  return String(n);
}

const AiUsageIndicator: FC<AiUsageIndicatorProps> = ({ societyId }) => {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const usage = useSelector((state: State) => state.ai?.usage);

  useEffect(() => {
    if (societyId) dispatch(getAiUsage(societyId) as any);
  }, [dispatch, societyId]);

  if (!usage || usage.limit == null) return null;

  const percent = usage.percent || 0;
  const used = usage.used || 0;
  const limit = usage.limit || 0;

  let barClass;
  if (percent >= 100) {
    barClass = 'is-exceeded';
  } else if (percent >= 80) {
    barClass = 'is-warning';
  } else {
    barClass = 'is-ok';
  }

  return (
    <div className="navi-sidebar__usage-footer">
      <div className="navi-sidebar__usage-row">
        <span className="navi-sidebar__usage-label">
          {t('AI_UsageThisMonth')}
        </span>
        <span className="navi-sidebar__usage-count">
          {formatTokens(used)} / {formatTokens(limit)} {t('AI_Tokens')}
        </span>
      </div>
      <div className={`navi-sidebar__usage-track ${barClass}`}>
        <div
          className="navi-sidebar__usage-fill"
          style={{ width: `${Math.min(100, Math.max(percent, 0.4))}%` }}
        />
      </div>
    </div>
  );
};

export default AiUsageIndicator;
